/** Translates bracket positions to application participants. No chess results or DB writes. */
class BracketsManagerAdapter {
  async pairSeeds(participants) {
    const [{ BracketsManager }, { InMemoryDatabase }] = await Promise.all([
      import('brackets-manager'),
      import('brackets-memory-db'),
    ]);
    const size = 2 ** Math.ceil(Math.log2(participants.length));
    const storage = new InMemoryDatabase();
    const manager = new BracketsManager(storage);
    // Keep the project's first–last seeding and one-based bracketIndex.
    const seeds = [];
    for (let i = 0; i < size / 2; i++) {
      seeds.push(String(i), size - 1 - i < participants.length ? String(size - 1 - i) : null);
    }
    await manager.create.stage({
      tournamentId: 0,
      name: 'Playoff',
      type: 'single_elimination',
      seeding: seeds,
      settings: { seedOrdering: ['natural'], balanceByes: false },
    });
    const registered = await storage.select('participant');
    const byId = new Map(registered.map(row => [row.id, participants[Number(row.name)]]));
    const rounds = await storage.select('round');
    const firstRound = rounds.find(round => round.number === 1);
    const matches = await storage.select('match', { round_id: firstRound.id });
    return matches.sort((a, b) => a.number - b.number).map(match => ({
      side1: byId.get(match.opponent1?.id) ?? byId.get(match.opponent2?.id),
      side2: match.opponent1 && match.opponent2 ? byId.get(match.opponent2.id) : null,
      isBye: !match.opponent1 || !match.opponent2,
      bracketIndex: match.number,
      eliminationParticipantCount: size,
    }));
  }
}

export default new BracketsManagerAdapter();
